export default __webpack_public_path__ + "static/media/1890.2460cb85.png";